import React, { ReactNode } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import "./TooltipWrapper.css";

interface TooltipWrapperProps {
  tooltipText: string;
  id: string;
  children: ReactNode;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({ tooltipText, id, children }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={id} className="custom-tooltip">
          {tooltipText}
        </Tooltip>
      }
    >
      <span style={{ cursor: 'help' }}>{children}</span>
    </OverlayTrigger>
  );
};

export default TooltipWrapper;
